import LAY_EXCEL from 'lay-excel'
export default {
  gotoexcel (obj) {
    let result = []
    result.push({ a: '“辅助就医”服务确认单', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '   区   街道/乡镇  编码：' + obj.areaCode, b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '一、基本信息', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '用户姓名：' + obj.userNane, b: '', c: '', d: '', e: '手机/固话：' + obj.userPhone, f: '', g: '', h: '' })
    result.push({ a: '用户身份证：' + obj.userIDcard, b: '', c: '', d: '', e: '身体疾病情况：' + obj.userHealth, f: '', g: '', h: '' })
    result.push({ a: '服务人员姓名：' + obj.csdName, b: '', c: '', d: '', e: '手机/固话：' + obj.csdPhone, f: '', g: '', h: '' })
    result.push({ a: '上门地址：' + obj.userAddress, b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '送回地址：' + obj.blackAddress, b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '预计上门时间：' + obj.doorTime, b: '', c: '', d: '', e: '就诊医院科室：' + obj.department, f: '', g: '', h: '' })
    result.push({ a: '服务开始时间：  月   日   时   分', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '二、服务确认', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '本人对上海康宁汇为老服务中心提供的“辅助就医”服务已完成，服务时长为     小时予以确认。', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '服务结束时间：  月   日   时   分', b: '', c: '', d: '', e: '本次服务评价：□满意 □一般 □不满意', f: '', g: '', h: '' })
    result.push({ a: '三、注意事项', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '“辅助就医”服务每年6次，每次4小时，全年累计不超过24小时（含）为免费；服务时长每超过15分钟的，按半小时计算，超过30分钟的，按一小时计算。超过每年度累计24小时的“辅助就医”服务部分，由用户自行承担。辅助就医期间，用户自己产生的交通费用及120费用，由用户自己承担。', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '用户（签名）：', b: '', c: '', d: '', e: '服务人员（签名）：', f: '', g: '', h: '' })
    result.push({ a: '直系亲属/监护人（签名）：', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '日期：              ', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    result.push({ a: '投诉电话：4008389909', b: '', c: '', d: '', e: '', f: '', g: '', h: '' })
    // 设置样式的函数
    LAY_EXCEL.setExportCellStyle(result, 'A1:H1', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '18', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A2:H2', {
      s: {
        font: { name: '宋体', bold: true },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'medium', color: { rgb: '1a1a1a' } }
          // left: { style: 'thin', color: { rgb: '1a1a1a' } },
          // right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A3:H3', {
      s: {
        font: { name: '微软雅黑', color: { rgb: '1a1a1a' }, bold: true },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A4:D4', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E4:H4', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A5:D5', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E5:H5', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A6:D6', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E6:H6', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A7:H7', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A8:H8', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A9:D9', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E9:H9', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A10:D10', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E10:H10', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A11:H11', {
      s: {
        font: { name: '微软雅黑', color: { rgb: '1a1a1a' }, bold: true },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A12:H12', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A13:D13', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E13:H13', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A14:H14', {
      s: {
        font: { name: '微软雅黑', color: { rgb: '1a1a1a' }, bold: true },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A15:H15', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A16:D16', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E16:H16', {
      s: {
        font: { name: '宋体' },
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A17:H17', {
      s: {
        font: { name: '宋体', bold: true },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A18:H18', {
      s: {
        font: { name: '宋体', bold: true },
        alignment: { horizontal: 'right', vertical: 'center' },
        border: {
          // top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'medium', color: { rgb: '1a1a1a' } },
          left: { style: 'medium', color: { rgb: '1a1a1a' } },
          right: { style: 'medium', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A19:H19', {
      s: {
        font: { name: '宋体', bold: true },
        alignment: { horizontal: 'right', vertical: 'center' }
      }
    })
    let mergeConf = LAY_EXCEL.makeMergeConfig([['A1', 'H1'], ['A2', 'H2'], ['A3', 'H3'], ['A4', 'D4'], ['E4', 'H4'], ['A5', 'D5'], ['E5', 'H5'], ['A6', 'D6'], ['E6', 'H6'],
      ['A7', 'H7'], ['A8', 'H8'], ['A9', 'D9'], ['E9', 'H9'], ['A10', 'D10'], ['E10', 'H10'], ['A11', 'H11'], ['A12', 'H12'], ['A13', 'D13'], ['E13', 'H13'], ['A14', 'H14'], ['A15', 'H15'],
      ['A16', 'D16'], ['E16', 'H16'], ['A17', 'H17'], ['A18', 'H18'], ['A19', 'H19']]) // 合并
    let rowConf = LAY_EXCEL.makeRowConfig([40, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 40, 30, 30, 70, 30, 30, 30, 30]) // 行高
    let colConf = LAY_EXCEL.makeColConfig({ 'A': 58.3, 'B': 58.3, 'C': 58.3, 'D': 58.3, 'E': 58.3, 'F': 58.3, 'G': 58.3, 'H': 58.3 }, 60)
    LAY_EXCEL.exportExcel(
      {sheet1: result},
      '陪医就诊工作确认单.xlsx',
      'xlsx',
      {
        extend: {
          // 以下配置仅 sheet1 有效
          '!merges': mergeConf, // 合并单元格信息
          '!cols': colConf, // 生成列宽配置
          '!rows': rowConf // 生成行高配置
          // extend 中可以指定某个 sheet 的属性，如果不指定 sheet 则所有 sheet 套用同一套属性
        }
      }
    )
  },
  goVisitExcel () {
    let result = []
    result.push({ a: '“居家探访和代理服务”项目反馈表 ①', b: '', c: '', d: '', e: '服务区域：', f: '' })
    result.push({ a: '服务单位：上海康宁汇为老服务中心', b: '', c: '', d: '服务人员：', e: '服务日期：', f: '' })
    result.push({ a: '用户姓名', b: '', c: '家庭住址', d: '', e: '电话号码', f: '' })
    result.push({ a: '项目明细', b: '名称', c: '', d: '居家探访和代理服务内容', e: '', f: '备注' })
    result.push({ a: '', b: '日常居家探访', c: '', d: '查看食品、药品保质期，检查生活设施', e: '', f: '' })
    result.push({ a: '', b: '', c: '', d: '水、电、燃气安全检测', e: '', f: '' })
    result.push({ a: '', b: '季度健康服务', c: '', d: '检查身体状况：体温、脉搏、呼吸、血压', e: '', f: '' })
    result.push({ a: '', b: '养老机构探访', c: '', d: '了解用户在养老机构入住期间的情况：环境设施、生活习惯、娱乐活动、护理人员的服务情况、换季的关怀、生日问候。', e: '', f: '' })
    result.push({ a: '', b: '住院探访', c: '', d: '了解进度、亲情陪伴，对护工护理情况进行了解，药品服用的方法，饮食情况。', e: '', f: '' })
    result.push({ a: '您对服务是否满意', b: '', c: '', d: '很满意  □    满意  □    一般 □     不满意 □', e: '', f: '' })
    result.push({ a: '意见和建议', b: '', c: '', d: '', e: '客户签名', f: '' })
    result.push({ a: '', b: '', c: '', d: '', e: '', f: '' })
    result.push({ a: '“居家探访和代理服务”项目反馈表 ①', b: '', c: '', d: '', e: '服务区域：', f: '' })
    result.push({ a: '服务单位：上海康宁汇为老服务中心', b: '', c: '', d: '服务人员：', e: '服务日期：', f: '' })
    result.push({ a: '用户姓名', b: '', c: '家庭住址', d: '', e: '电话号码', f: '' })
    result.push({ a: '项目明细', b: '名称', c: '', d: '居家探访和代理服务内容', e: '', f: '备注' })
    result.push({ a: '', b: '日常居家探访', c: '', d: '查看食品、药品保质期，检查生活设施', e: '', f: '' })
    result.push({ a: '', b: '', c: '', d: '水、电、燃气安全检测', e: '', f: '' })
    result.push({ a: '', b: '季度健康服务', c: '', d: '检查身体状况：体温、脉搏、呼吸、血压', e: '', f: '' })
    result.push({ a: '', b: '养老机构探访', c: '', d: '了解用户在养老机构入住期间的情况：环境设施、生活习惯、娱乐活动、护理人员的服务情况、换季的关怀、生日问候。', e: '', f: '' })
    result.push({ a: '', b: '住院探访', c: '', d: '了解进度、亲情陪伴，对护工护理情况进行了解，药品服用的方法，饮食情况。', e: '', f: '' })
    result.push({ a: '您对服务是否满意', b: '', c: '', d: '很满意  □    满意  □    一般 □     不满意 □', e: '', f: '' })
    result.push({ a: '意见和建议', b: '', c: '', d: '', e: '客户签名', f: '' })
    // 设置样式的函数
    LAY_EXCEL.setExportCellStyle(result, 'A1:D1', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '20', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E1:F1', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A2:F2', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A3:F3', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A4:A4', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'B4:F4', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '14', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A5:C5', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D5:F5', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A6:C6', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D6:F6', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A7:C7', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D7:F7', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A8:C8', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D8:F8', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A9:C9', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D9:F9', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A10:F10', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A11:F11', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A12:F12', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' }
      }
    })

    LAY_EXCEL.setExportCellStyle(result, 'A13:D13', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '20', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E13:F13', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A14:F14', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A15:F15', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A16:A16', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'B16:F16', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '14', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A17:C17', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D17:F17', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A18:C18', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D18:F18', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A19:C19', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D19:F19', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A20:C20', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D20:F20', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A21:C21', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D21:F21', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A22:F22', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A23:F23', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })

    let mergeConf = LAY_EXCEL.makeMergeConfig([['A1', 'D1'], ['E1', 'F1'], ['A2', 'C2'], ['E2', 'F2'], ['A4', 'A9'], ['B4', 'C4'], ['D4', 'E4'],
      ['B5', 'C6'], ['B7', 'C7'], ['B8', 'C8'], ['B9', 'C9'], ['A10', 'C10'], ['D10', 'F10'], ['B11', 'D11'], ['A12', 'F12'],
      ['A13', 'D13'], ['E13', 'F13'], ['A14', 'C14'], ['E14', 'F14'], ['A16', 'A21'], ['B16', 'C16'], ['D16', 'E16'],
      ['B17', 'C18'], ['B19', 'C19'], ['B20', 'C20'], ['B21', 'C21'], ['A22', 'C22'], ['D22', 'F22'], ['B23', 'D23']]) // 合并
    let rowConf = LAY_EXCEL.makeRowConfig([41.25, 33.5, 33.5, 33.5, 33.5, 33.5, 33.5, 51.5, 45, 32, 32, 31.5,
      41.25, 33.5, 33.5, 33.5, 33.5, 33.5, 33.5, 51.5, 45, 32, 32]) // 行高
    let colConf = LAY_EXCEL.makeColConfig({ 'A': 62, 'B': 85, 'C': 52, 'D': 252, 'E': 56, 'F': 96 }, 60) // 30
    LAY_EXCEL.exportExcel(
      {sheet1: result},
      '居家探访和代理服务.xlsx',
      'xlsx',
      {
        extend: {
          // 以下配置仅 sheet1 有效
          '!merges': mergeConf, // 合并单元格信息
          '!cols': colConf, // 生成列宽配置
          '!rows': rowConf // 生成行高配置
          // extend 中可以指定某个 sheet 的属性，如果不指定 sheet 则所有 sheet 套用同一套属性
        }
      }
    )
  },
  goHospitalExcel () {
    let result = []
    result.push({ a: '“居家探访和代理服务”项目反馈表 ②', b: '', c: '', d: '', e: '服务区域：', f: '' })
    result.push({ a: '服务单位：上海康宁汇为老服务中心', b: '', c: '', d: '服务人员：', e: '服务日期：', f: '' })
    result.push({ a: '用户姓名', b: '', c: '家庭住址', d: '', e: '电话号码', f: '' })
    result.push({ a: '项目明细', b: '名称', c: '', d: '居家探访和代理服务内容', e: '', f: '备注' })
    result.push({ a: '', b: '医疗机构代理服务', c: '', d: '入院流程：接到电话→代理人上门→通报街道→沟通确认医院、安排交通工具（120 救护车、出租车、私家车）→到达医院→按医院要求协助办理住院→协助请好护工', e: '', f: '' })
    result.push({ a: '', b: '', c: '', d: '出院流程：接到出院通知→代理人上医院→协助办理出院手续→协助整理物品→安排交通工具（120 救护车、出租车、私家车）→安置用户到家', e: '', f: '' })
    result.push({ a: '', b: '养老机构代理服务', c: '', d: '养老院入住前期事项办理流程：提出申请→协助用户办理长护险→陪同去居委登记→陪同去社区事务中心登记→陪同等级评定（4 级以上符合入住件）→陪同选择参观养老院→陪同进行养老院身体健康评估→合格→协助预约床位、陪同签订入住协议', e: '', f: '' })
    result.push({ a: '您对服务是否满意：   很满意 □    满意  □    一般 □     不满意 □', b: '', c: '', d: '', e: '', f: '' })
    result.push({ a: '意见和建议', b: '', c: '', d: '', e: '客户签名', f: '' })
    result.push({ a: '', b: '', c: '', d: '', e: '', f: '' })
    result.push({ a: '“居家探访和代理服务”项目反馈表 ②', b: '', c: '', d: '', e: '服务区域：', f: '' })
    result.push({ a: '服务单位：上海康宁汇为老服务中心', b: '', c: '', d: '服务人员：', e: '服务日期：', f: '' })
    result.push({ a: '用户姓名', b: '', c: '家庭住址', d: '', e: '电话号码', f: '' })
    result.push({ a: '项目明细', b: '名称', c: '', d: '居家探访和代理服务内容', e: '', f: '备注' })
    result.push({ a: '', b: '医疗机构代理服务', c: '', d: '入院流程：接到电话→代理人上门→通报街道→沟通确认医院、安排交通工具（120 救护车、出租车、私家车）→到达医院→按医院要求协助办理住院→协助请好护工', e: '', f: '' })
    result.push({ a: '', b: '', c: '', d: '出院流程：接到出院通知→代理人上医院→协助办理出院手续→协助整理物品→安排交通工具（120 救护车、出租车、私家车）→安置用户到家', e: '', f: '' })
    result.push({ a: '', b: '养老机构代理服务', c: '', d: '养老院入住前期事项办理流程：提出申请→协助用户办理长护险→陪同去居委登记→陪同去社区事务中心登记→陪同等级评定（4 级以上符合入住件）→陪同选择参观养老院→陪同进行养老院身体健康评估→合格→协助预约床位、陪同签订入住协议', e: '', f: '' })
    result.push({ a: '您对服务是否满意：   很满意 □    满意  □    一般 □     不满意 □', b: '', c: '', d: '', e: '', f: '' })
    result.push({ a: '意见和建议', b: '', c: '', d: '', e: '客户签名', f: '' })
    // 设置样式的函数
    LAY_EXCEL.setExportCellStyle(result, 'A1:D1', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '20', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E1:F1', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A2:F2', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A3:F3', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A4:A4', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'B4:F4', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '14', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A5:C5', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D5:F5', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A6:C6', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D6:F6', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A7:C7', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D7:F7', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A8:F8', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A9:F9', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A10:F10', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A11:D11', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '20', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'E11:F11', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A12:F12', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A13:F13', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A14:A14', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'B14:F14', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '14', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A15:C15', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D15:F15', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A16:C16', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D16:F16', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A17:C17', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'D17:F17', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'left', vertical: 'center', wrapText: 1 },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A18:F18', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    LAY_EXCEL.setExportCellStyle(result, 'A19:F19', {
      s: {
        font: {color: {rgb: '1a1a1a'}, name: '宋体', sz: '11', bold: true},
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '1a1a1a' } },
          bottom: { style: 'thin', color: { rgb: '1a1a1a' } },
          left: { style: 'thin', color: { rgb: '1a1a1a' } },
          right: { style: 'thin', color: { rgb: '1a1a1a' } }
        }
      }
    })
    let mergeConf = LAY_EXCEL.makeMergeConfig([['A1', 'D1'], ['E1', 'F1'], ['A2', 'C2'], ['E2', 'F2'], ['A4', 'A7'], ['B4', 'C4'], ['D4', 'E4'],
      ['B5', 'C6'], ['B7', 'C7'], ['A8', 'F8'], ['B9', 'D9'], ['A10', 'F10'],
      ['A11', 'D11'], ['E11', 'F11'], ['A12', 'C12'], ['E12', 'F12'], ['A14', 'A17'], ['B14', 'C14'], ['D14', 'E14'],
      ['B15', 'C16'], ['B17', 'C17'], ['A18', 'F18'], ['B19', 'D19']]) // 合并
    let rowConf = LAY_EXCEL.makeRowConfig([41.25, 33.5, 33.5, 33.5, 66, 68, 87, 30.5, 33, 22.5,
      41.25, 33.5, 33.5, 33.5, 66, 68, 87, 30.5, 33]) // 行高
    let colConf = LAY_EXCEL.makeColConfig({ 'A': 62, 'B': 85, 'C': 52, 'D': 242, 'E': 56, 'F': 96 }, 60) // 30
    LAY_EXCEL.exportExcel(
      {sheet1: result},
      '住院出院反馈表.xlsx',
      'xlsx',
      {
        extend: {
          // 以下配置仅 sheet1 有效
          '!merges': mergeConf, // 合并单元格信息
          '!cols': colConf, // 生成列宽配置
          '!rows': rowConf // 生成行高配置
          // extend 中可以指定某个 sheet 的属性，如果不指定 sheet 则所有 sheet 套用同一套属性
        }
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/utils/excel.js